var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', _vm._g(_vm._b({
    directives: [{
      name: "no-scroll",
      rawName: "v-no-scroll"
    }],
    attrs: {
      "content-class": _vm.$attrs['content-class'] + (_vm.loading ? ' hidden' : '')
    }
  }, 'v-dialog', _vm.$attrs, false), _vm.$listeners), [_vm.loading ? _c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "transition": null,
      "value": true
    },
    on: {
      "input": function (v) {
        return _vm.$emit('input', v);
      }
    }
  }, [_c('div', {
    staticClass: "fill-height d-flex justify-center align-center",
    on: {
      "click": function ($event) {
        return _vm.$emit('input', false);
      }
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "color": "white",
      "indeterminate": ""
    }
  })], 1)]) : _vm._e(), _vm._t("default")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }